var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftEmptyGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h200v200H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.068 36.878A4.878 4.878 0 0 1 56.946 32h72.474a4.878 4.878 0 1 1 0 9.756h-15.331a4.878 4.878 0 1 0 0 9.756h35.54a6.272 6.272 0 1 1 0 12.544H40.221a6.272 6.272 0 1 1 0-12.544h29.965a4.867 4.867 0 0 1-1.742-.32 4.88 4.88 0 0 0 0-9.116 4.867 4.867 0 0 1 1.742-.32h-13.24a4.878 4.878 0 0 1-4.878-4.878ZM158.688 57.784a6.272 6.272 0 0 1 6.272-6.272h12.543a6.272 6.272 0 1 1 0 12.544H164.96a6.272 6.272 0 0 1-6.272-6.272ZM40.221 73.812a6.272 6.272 0 1 0 0 12.543h85.715a6.272 6.272 0 0 0 0-12.543H40.221ZM7.469 101.338a5.226 5.226 0 0 1 5.226-5.226h42.509a5.226 5.226 0 1 1 0 10.452h-2.09a5.227 5.227 0 0 0 0 10.453h33.449a5.226 5.226 0 1 1 0-10.453h78.745a5.227 5.227 0 1 1 0 10.453h-14.285a5.227 5.227 0 1 0 0 10.453h8.014a5.227 5.227 0 0 1 0 10.453h-32.056a5.227 5.227 0 0 1 0 10.453H85.866a5.227 5.227 0 0 0 0 10.453h6.272a5.227 5.227 0 0 1 0 10.453H48.932a5.226 5.226 0 1 1 0-10.453h.697a5.226 5.226 0 1 0 0-10.453H5.726a5.226 5.226 0 1 1 0-10.453h20.906a5.226 5.226 0 1 1 0-10.453h1.046a5.226 5.226 0 1 0 0-10.453h-2.44a5.226 5.226 0 1 1 0-10.453H12.696a5.226 5.226 0 0 1-5.226-5.226ZM182.033 106.564a5.227 5.227 0 0 0 0 10.453h13.241a5.226 5.226 0 0 0 0-10.453h-13.241Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.845 150.467a4.181 4.181 0 0 0 0 8.362h9.059a4.181 4.181 0 0 0 0-8.362h-9.059Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.621 35.53a2.062 2.062 0 1 1 0 4.124H41.248a2.062 2.062 0 0 1 0-4.124H53.62ZM30.936 35.53a2.062 2.062 0 1 1 0 4.124H18.562a2.062 2.062 0 0 1 0-4.124h12.374ZM38.154 55.121a2.062 2.062 0 1 1-4.125 0V42.748a2.062 2.062 0 0 1 4.125 0V55.12ZM38.154 32.436a2.062 2.062 0 0 1-4.125 0V20.062a2.062 2.062 0 0 1 4.125 0v12.374ZM186.895 121.312a1.09 1.09 0 0 1 1.54 1.539l-4.618 4.618a1.088 1.088 0 1 1-1.539-1.54l4.617-4.617ZM178.429 129.778a1.09 1.09 0 0 1 1.54 1.539l-4.618 4.618a1.09 1.09 0 0 1-1.54-1.54l4.618-4.617ZM188.435 134.395a1.09 1.09 0 0 1-1.54 1.54l-4.617-4.618a1.088 1.088 0 1 1 1.539-1.539l4.618 4.617ZM179.969 125.929a1.09 1.09 0 0 1-1.54 1.54l-4.618-4.618a1.088 1.088 0 1 1 1.54-1.539l4.618 4.617ZM25.752 105.088a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531ZM25.752 117.061a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531ZM36.092 113.252a1.088 1.088 0 1 1 0 2.177h-6.53a1.089 1.089 0 0 1 0-2.177h6.53ZM24.12 113.252a1.088 1.088 0 1 1 0 2.177h-6.532a1.089 1.089 0 0 1 0-2.177h6.531Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.854,
    cy: 104.354,
    fill: "#EEF2F5",
    r: 4.354
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.854,
    cy: 168.354,
    fill: "#EEF2F5",
    r: 4.354
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.384 181.048a8.164 8.164 0 1 0 0-16.328 8.164 8.164 0 0 0 0 16.328Zm0 2.721c6.012 0 10.885-4.873 10.885-10.885 0-6.011-4.873-10.884-10.885-10.884-6.011 0-10.884 4.873-10.884 10.884 0 6.012 4.873 10.885 10.884 10.885ZM89.384 35.048a8.163 8.163 0 1 0 0-16.327 8.163 8.163 0 0 0 0 16.327Zm0 2.72c6.012 0 10.885-4.872 10.885-10.884 0-6.01-4.873-10.884-10.885-10.884-6.01 0-10.884 4.873-10.884 10.884 0 6.012 4.873 10.885 10.884 10.885Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.594 159.885h73.441c5.1 0 9.235-4.197 9.235-9.373v-46.87H54.36v46.87c0 5.176 4.134 9.373 9.234 9.373Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C7D8",
    fillOpacity: 0.5,
    d: "M54.359 103.642h91.91v6.859h-91.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.442 81.693H57.057c-5.278 0-9.557 4.196-9.557 9.371v8.516c0 2.243 1.855 4.062 4.143 4.062h98.714c2.29 0 4.143-1.819 4.143-4.062v-8.516c0-5.175-4.279-9.37-9.557-9.37H85.442Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.83 81.693H82.544c-12.905-1.768-28.7-13.036-24.855-24.925 3.498-10.82 13.993-16.292 24.723-16.228 15.148.08 19.071 30.137 19.071 30.137h.406s3.926-30.056 19.071-30.137c10.725-.064 21.223 5.408 24.721 16.228 3.844 11.89-11.951 23.157-24.851 24.925Zm11.268-30.23s-.47 14.791-21.467 25.837c0 0 3.97-18.989 21.467-25.836Zm-60.646 0C88.942 58.31 92.91 77.3 92.91 77.3 71.917 66.254 71.452 51.464 71.452 51.464Z",
    fill: "url(#d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 99.001,
    y1: 96.001,
    x2: 101.501,
    y2: 166.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 101.5,
    y1: 83.001,
    x2: 104.5,
    y2: 109.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 101.685,
    y1: 40.539,
    x2: 101.685,
    y2: 81.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h200v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftEmptyGrayIcon);
export default __webpack_public_path__ + "static/media/gift-empty-gray-icon.7c0fb5ceff8b09cbd1a1d59bae8c8e26.svg";
export { ForwardRef as ReactComponent };